import * as React from 'react';
import { connect } from 'react-redux';
import { dmvSearch } from './redux-objects/actions';
import DataTable from '../DataTable';
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { Provider } from 'react-redux';
import { Button } from 'react-bootstrap';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import ReactDOM from 'react-dom';
import * as urls from '../shared/urls';
import { IDmvSearchResult } from './business-objects/types';
import ViewAllButton from '../DocumentViewer/ViewAllButton';
import Store from '../../store/Store';
import rootReducer from '../../store/Reducers';
import { QueueStartDate } from '../WorkflowQueues/common';

const reduxStore = Store({}, rootReducer);

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IDmvSearchActionProps {
  dmvSearch?: (url: string) => void;
}

interface IDmvSearchStateProps {
  webServiceURL: string;
  searchResults: IDmvSearchResult[];
}

interface IDmvSearchProps extends IDmvSearchActionProps, IDmvSearchStateProps { }

const initialState = {
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  crashKey: '',
  isGetingImage: false,
};
type DmvSearchState = Readonly<typeof initialState>;
class DmvSearch extends React.Component<IDmvSearchProps, DmvSearchState> {
  public constructor(props: IDmvSearchProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
  }

  doSearch() {
    let uri = this.props.webServiceURL + urls.DMV_SEARCH;

    var params = {
      crashKey: this.state.crashKey,
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    this.props.dmvSearch(uri);
  }

  handleSearchButton(event: React.MouseEvent<HTMLElement>) {
    this.doSearch();
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate });
    }
  }

  handleCrashKeyChange(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ crashKey: el.value });
  }

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '150px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Provider store={reduxStore}>
                <ViewAllButton
                  reportId={rowData?.reportId}
                  dbToSearch='private'
                />
              </Provider>
            </div>,
            td
          ),
      },
      {
        targets: 1,
        render: function (data) {
          return moment(data).format('MM/DD/YYYY');
        },
      },
    ];

    const columns = [
      {
        title: 'Available Actions',
        data: 'id',
      },
      {
        title: 'Crash Date',
        data: 'crashDate',
      },
      {
        title: 'Crash Key',
        data: 'crashKey',
      },
      {
        title: 'Drivers Last Names',
        data: 'driversLastNames',
      },
      {
        title: 'Drivers License Number',
        data: 'driversLicenseNumber',
      },
      {
        title: 'County',
        data: 'county',
      },
    ];
    const options = {
      dom: 'Bfrtip',
    };

    return (
      <div className='app'>
        <div className='row'>
          <div className='col-sm-6'>
            <h3>DMV Search</h3>
          </div>
        </div>

        <hr />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId='dmvSearchsStartDate'>
              <Form.Label>Crash Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId='dmvSearchsStartDate' // PropTypes.string.isRequired,
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId='dmvSearchsEndDate' // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>

            <Form.Group as={Col} controlId='exampleForm.ControlSelect1'>
              <Form.Label>Crash Key</Form.Label>
              <Form.Control
                type='text'
                value={this.state.crashKey}
                onChange={(e) => this.handleCrashKeyChange(e)}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId='searchButton'>
              <Button
                variant='primary'
                onClick={(e) => this.handleSearchButton(e)}
              >
                Search
              </Button>
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>
        <DataTable
          id='tblDmvSearchs'
          data={this.props.searchResults}
          columns={columns}
          columnDefs={columnDefs}
          actionsColumn='first'
          select={false}
          {...options}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    searchResults: state.DmvSearch.results,
  };
}

const mapDispatchToProps = {
  dmvSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(DmvSearch);
